import { render, staticRenderFns } from "./RemitaInvoice.vue?vue&type=template&id=3f074ca6&"
import script from "./RemitaInvoice.vue?vue&type=script&lang=js&"
export * from "./RemitaInvoice.vue?vue&type=script&lang=js&"
import style0 from "./RemitaInvoice.vue?vue&type=style&index=0&id=3f074ca6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports